import { createApp } from "vue"
import App from "./App"
import router from "./router"
import { createPinia } from "pinia"
import "@/style/iconfont/iconfont"
import "vant/lib/index.css"
import "ant-design-vue/dist/reset.css"
import { Lazyload } from "vant"

/* if (process.env.NODE_ENV != "production") {
  const VConsole = require("vconsole")
  new VConsole()
} */

createApp(App).use(createPinia()).use(Lazyload).use(router).mount("#app")
